import styled from 'styled-components';
import { baseVariables } from '../../styles';

export const Wrapper = styled.div`
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
  padding: 2rem;
  border-radius: var(--t-cards-border-radius);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  margin: 30px;

  @media ${baseVariables.mediaQuery.md} {
    padding: 3rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding: 4rem;
  }
`;

export const HighlightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HighlightContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
